import type { ICustomCategoryResponse } from "app/services/category/userCustomCategoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import { ECategoryType } from "app/common/services/categoryService.types";
import type { IDomains } from "../MarketBuilder.types";
import { EAssetType } from "app/UtilitiesAndConstants/types/assetType";

export const updateMarket = (
    marketName: string,
    domains: IDomains,
    countryId: number,
    categoryId: string,
): Promise<ICustomCategoryResponse[]> => {
    const entitiesArr = [],
        segmentsArr = [];
    domains.forEach((entity) => {
        const { type, id, domain } = entity;
        type === EAssetType.Segment ? segmentsArr.push(id) : entitiesArr.push(domain);
    });

    const updateMarketPromise = UserCustomCategoryService.updateCustomCategory({
        name: marketName,
        domains: entitiesArr,
        categoryType: ECategoryType.MARKET_LIST,
        country: countryId,
        id: categoryId,
        segments: segmentsArr,
    });
    return updateMarketPromise;
};
